import React from 'react';
import styled from 'styled-components';
import { constants } from '../../constants';

export const JoinCallMask = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: calc(100vh - 70px);
    position: relative;
    background-color: rgba(0,0,0,0.9);
    top: 0px;
    
    > p {
    color: white;
    position: relative;
    z-index: 4;
    font-family: Open Sans;
    font-weight: 300;
    font-size: 13px;
    margin-left: 25px;
    margin-right: 25px;
    text-align: center;
        > a {
            color: rgb(150,190,255);
        }
    }
    
    > div.maskTint {
        background-image: url('https://firebasestorage.googleapis.com/v0/b/cyno-corporate-test.appspot.com/o/iStock-508387030_small.jpg?alt=media&token=bc7f950d-99be-4a1d-b188-65828167aa74');
        background-size: cover;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-repeat:no-repeat;
        background-position: center center;
    }

    > div.maskImage {
        background-color: rgba(0, 0, 10, 0.7);
        z-index: 1;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-position: 50% 50%;
        background-repeat: no-repeat;
    }

    > button.text {
        position: relative;
        z-index: 4;
        background-color: #ffcd00;
        border: 3px solid rgba(0,0,0,0.1);
        border-radius: 50px;
        height: 50px;
        font-size: 20px;
        color: rgba(0,0,0,0.6);
        padding: 0px 20px;
        margin-left: 10px;
        margin-right: 10px;
        box-shadow: 2px 2px 15px rgba(0,0,0,0.3);
        &:hover {
            backgorund-color: rgba(0,0,255, 0.5);
        }
    }
`;

export const HideInteraction = styled.button`
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    justify-content: center;
    background: white;
    font-size: 22px;
    /* padding-top: 9px; */
    color: rgb(74, 196, 209);
    border: none;
    height: 50px;
    width: 50px;
    border-radius: 0 0 100% 0;
    margin-top: -3px;
    margin-left: -1px;
    box-shadow: 0px 0px 18px 1px rgba(0, 0, 0, 0.15);
`;

export const VideoContainer = styled.div`
    background-color: black;
    display: flex;
    justify-content: center;
    flex-direction: row;
    align-items: stretch;
    /* height: calc(100vh - 73px); */
    /* width: 100vw; */
    flex: 1;
    min-height: calc(100vh - 73px);
    @media (max-width: 650px) {
        max-height: calc(100vh - 70px) !important;  
    }
`;

export const OuterContainer = styled.div`
    /* background-color: black; */
    display: flex;
    justify-content: flex-start;
    flex-flow: row nowrap;
    align-items: stretch;
    /* height: calc(100vh - 73px); */
    width: 100vw;
    flex: 1;
    background-color: black;
    @media (max-width: 650px) {
        max-height: calc(100vh - 70px) !important;  
    }
    max-width: ${constants.layout.contentWidth.maxWidth}px;
    height: calc(100vh - 73px);
`;

export const Publisher = styled.div`
    position: relative;
    /* display: flex; */
    /* height: 100%;
    width: 100%; */
    /* justify-content: flex-end;
    align-items: flex-end; */
    right: 140px;
    bottom: -30px;
    /* margin-bottom: -30px; */
    > div {
        position: absolute;
        height: 100px;
        width: 100px;
        border: 1px solid white;
        z-index: 1;
        box-shadow: 2px 2px 15px rgba(0,0,0,0.3);
    }
`;

const VideoSectionStyles = styled.div`
    ${props => props.hideVideoSection ? 'display: none;' : ''}
    /* display: flex;
    flex-flow: row nowrap; */
    flex: 2;
`;
export const VideoSection = ({ style, children, ...rest }) => (
    <VideoSectionStyles style={style} {...rest}>
        {children}
    </VideoSectionStyles>
);

export const ControlsContainer = styled.div`
    position: relative;
    /* display: flex; */
    /* flex: 1; */
    height: 100%;
    width: 100%;
    /* justify-content: center;
    align-items: flex-end; */
    /* right: 30px; */
    bottom: 84px;
`;

export const Controls = styled.div`
    /* position: relative; */
    display: flex;
    flex: 1;
    /* height: 100%;
    width: 100%; */
    justify-content: center;
    align-items: flex-end;
    /* right: 30px;
    bottom: 30px; */

    /* @media (max-width: 450px) {
        justify-content: flex-start;
        left: 5%;
    } */

    > div {
    /* position: absolute; */
    display: flex;
    flex-flow: row nowrap;
    height: 75px;
    
    
    z-index: 1;
    > button.icon {
        background-color: red;
        border: 2px solid white;
        border-radius: 50px;
        height: 50px;
        font-size: 20px;
        color: white;
        width: 50px;
        box-shadow: 2px 2px 15px rgba(0,0,0,0.3);
        margin-left: 10px;
        margin-right: 10px;
        > img {
        position: relative;
        width: 25px;
        height: 25px;
        
        margin-bottom: -9px;
        bottom: 0px;
        filter: invert(100%);
        }
    }
    
    > button.icon.white {
        background-color: rgba(255,255,255,0.8);
        border: 2px solid rgba(255,255,255, 0.8);
        border-radius: 50px;
        height: 50px;
        font-size: 20px;
        color: rgba(0,0,0,0.8);
        width: 50px;
        box-shadow: 2px 2px 15px rgba(0,0,0,0.3);
        margin-left: 10px;
        margin-right: 10px;
        &:hover {

        }
        > img {
        position: relative;
        width: 28px;
        height: 28px;
        opacity: 0.8;
        margin-bottom: -9px;
        bottom: 2px;
        filter: invert(0%);
        }
    }
    > button.icon.black {
        background-color: rgba(0,0,0,0.8);
        border: 2px solid rgba(255,255,255,0.8);
        border-radius: 50px;
        height: 50px;
        font-size: 20px;
        color: rgba(255,255,255, 0.8);
        width: 50px;
        box-shadow: 2px 2px 15px rgba(0,0,0,0.3);
        margin-left: 10px;
        margin-right: 10px;
        > img {
        position: relative;
        width: 28px;
        height: 28px;
        opacity: 0.8;
        margin-bottom: -9px;
        bottom: 2px;
        filter: invert(100%);
        }
    }
    }
`;

const SubscriberStyles = styled.div`
    min-height: 100%;
    height: 100%;
    width: 100%;

    justify-content: center;
    align-items: center;
    > div {
    min-height: 100%;
    height: 100%;
    /*border: 1px solid orange;*/
    
    > div {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: row;
        
        flex-wrap: wrap;
        @media (max-width: 770px) {
        flex-direction: column;
        max-height: calc(100vh - 100px);  
        }

        height: 100%;
        width: 100%;
        /*border: 5px solid purple;*/
        
        
        > div {
        display: flex;
        flex: 1 1 50%;
        /*border: 3px solid green;*/
        max-width: 1200px;
        min-width: 400px;
        
        width: 100%;
        height: 100%;
        > div.OTSubscriberContainer.OTSubscriberContainer {
            flex: 1 1 100%;
            height: 100%;
            width: 100%;
            /*border: 1px solid red;*/
            min-height: 100%;
            min-width: 100%;
        
            > div {
            /* THIS IS THE VOLUME BAR */ 
            }
        }
        }
    }
}
`;

export const Subscriber = ({ style, children, ...rest }) => (
    <SubscriberStyles style={style} {...rest}>
        {children}
    </SubscriberStyles>
);



// WEBPACK FOOTER //
// ./src/js/components/VideoUI/styles.js